import IdeyaModal from '../../../../../common/antd/ideya-modal.tsx'
import { useLazySendInviteEmailQuery } from '../../../../../apis/user-management/user-management-api.api.ts'
import { IdeyaSpinner } from '../../../../../common/components/ideya-spinner.tsx'
import message from 'antd/es/message/index'
import notification from 'antd/es/notification/index'
import { useCallback, useEffect } from 'react'
import { getErrorDescription } from '../../../../../redux/utils.ts'
import { useTranslation } from 'react-i18next'

interface InviteUserModalProps {
  inviteUserId: string | null
  showInviteModal: boolean
  setShowInviteModal: (v: boolean) => void
  onCancel: () => void
}

export const InviteUserModal: React.FC<InviteUserModalProps> = ({
  inviteUserId,
  showInviteModal,
  setShowInviteModal,
  onCancel,
}) => {
  const [
    SendInviteEmail,
    { isLoading, isFetching, isSuccess, isError, error, reset },
  ] = useLazySendInviteEmailQuery()
  const [messageApi, messageContextHolder] = message.useMessage()
  const [notificationApi, notificationContextHolder] =
    notification.useNotification()
  const { t } = useTranslation()

  const handleSendInvite = async () => {
    if (!inviteUserId) return

    await SendInviteEmail({ id: inviteUserId })
    setShowInviteModal(false)
  }

  const success = useCallback(() => {
    messageApi.open({
      type: 'success',
      content: t('user_management.user_modal.invite_modal.success_message'),
    })
  }, [messageApi, t])

  const errorNotification = useCallback(
    (description: string) => {
      notificationApi.error({
        message: 'Error',
        description,
        placement: 'topRight',
      })
    },
    [notificationApi]
  )

  useEffect(() => {
    if (isSuccess) {
      success()
      onCancel()
      reset()
    }
  }, [isSuccess, onCancel, reset, success])

  useEffect(() => {
    if (isError) {
      const description = getErrorDescription(error)
      errorNotification(description)
      reset()
    }
  }, [isError, error, reset, errorNotification])

  return (
    <>
      {messageContextHolder}
      {notificationContextHolder}
      <IdeyaModal
        open={showInviteModal}
        title={t('user_management.user_modal.invite_modal.send_invite_email')}
        destroyOnHidden
        onCancel={onCancel}
        onOk={handleSendInvite}
      >
        {isFetching || isLoading ? <IdeyaSpinner /> : <></>}
      </IdeyaModal>
    </>
  )
}
